import React, { useState } from "react";
import { ApiService } from "../services";
import { useSnackbar } from "react-simple-snackbar";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import FormikControl from "../formikComponents/formikControl";
import GButton from "../gComponents/gButton";

export default function EventForm(props) {
  const [openSnackbar] = useSnackbar();
  const [isDisabled, setIsDisabled] = useState(false);
  const initialValues = {
    title: !props.isEmpty ? props.data.title : "",
    date: !props.isEmpty ? new Date(props.data.date) : null,
  };

  const handleChange = (d) => {
    // var date = new Date(d).getDate(); //Current Date
    var date = (new Date(d).getDate() < 10 ? "0" : "") + new Date(d).getDate();
    // var month = new Date(d).getMonth() + 1; //Current Month
    var month =
      (new Date(d).getMonth() + 1 < 10 ? "0" : "") +
      (new Date(d).getMonth() + 1);
    var year = new Date(d).getFullYear(); //Current Year
    console.log(year + "-" + month + "-" + date);
    return year + "-" + month + "-" + date;
  };

  const onSubmit = (values) => {
    setIsDisabled(true);
    console.log(values);
    values.date = handleChange(values.date);
    // return;
    var hitMethod = !props.isEmpty ? "PUT" : "POST";
    var hitUrl = !props.isEmpty ? "events/" + props.data.id : "events";
    ApiService({ method: hitMethod, route: hitUrl, body: values }).then(
      (response) => {
        console.log("r" + response.status_code);
        if (response.data.status_code === 1) {
          props.setCevisible(false);
          props.onSubmit(response.data.data);
        }
        setIsDisabled(false);
        openSnackbar(response.data.message);
        return;
      }
    );
  };

  const validationSchema = Yup.object({
    title: Yup.string().required("Required"),
    date: Yup.string().nullable().required("Required"),
  });

  if (props.cevisible === false) {
    return null;
  }
  return (
    <>
      <div className="modal-header">
        {!props.isEmpty ? "Edit" : "Create"} Event
      </div>
      <div className="modal-body">
        <Formik
          initialValues={initialValues}
          onSubmit={onSubmit}
          validationSchema={validationSchema}
        >
          <Form>
            <FormikControl
              control="input"
              type="text"
              label="Title"
              name="title"
            />

            <FormikControl
              control="date"
              label="Date"
              name="date"
              format="yyyy-MM-dd"
              onKeyDown={(e) => e.preventDefault()}
            />
            <br />

            <GButton
              type="submit"
              disabled={isDisabled}
              variant="condensed"
              children={!props.isEmpty ? "Update" : "Create"}
              style={{ width: "calc(100% - 30px)", margin: "0 15px" }}
            />
          </Form>
        </Formik>
      </div>
    </>
  );
}
